import { DocumentRelationPreview } from '@pages/DocumentPage/DocumentForm/DocumentRelationPreview'
import React from 'react'
import { EntryDocumentLink } from './interactive.styled'

type Props = {
  documentId: number
  children: React.ReactNode
}

export const ReportDocumentPreview: React.FC<Props> = ({ documentId, children }) => (
  <span onClick={event => event.stopPropagation()}>
    <DocumentRelationPreview documentId={documentId} inline>
      <EntryDocumentLink type="button">{children}</EntryDocumentLink>
    </DocumentRelationPreview>
  </span>
)
